<div class="container-fluid">
  <form [formGroup]="stepFourForm">
    <div class="form-group">
      <div class="row mt-2">
        <div class="col-12 col-md-6 mb-3">
          <label for="product_installdate" style="font-weight: bold;">{{"SYSTEM.STEPFOUR.INSTALLATIONDATE" |
            translate}}<sup>*</sup></label>
          <input type="date" name="product_installdate" id="product_installdate" formControlName="product_installdate"
            class="form-control" placeholder="{{'SYSTEM.STEPFOUR.DATEPLACEHOLDER' | translate}}"
            [class.is-invalid]="stepFourForm.get('product_installdate')?.invalid && (stepFourForm.get('product_installdate')?.dirty || submitted)">
          <div class="text-danger mt-1"
            *ngIf="stepFourForm.get('product_installdate')?.invalid && (stepFourForm.get('product_installdate')?.dirty || submitted)"
            style="font-size: small;">{{"SYSTEM.STEPFOUR.DATEERROR" | translate}}</div>
        </div>
        <div class="col-12 col-md-6 mb-3">
          <label for="product_systemcomposition" style="font-weight: bold;">{{"SYSTEM.STEPFOUR.SYSCOMPOSITION" |
            translate}}<sup>*</sup></label>
          <select class="form-select" aria-label="select example" id="product_systemcomposition"
            formControlName="product_systemcomposition"
            [class.is-invalid]="stepFourForm.get('product_systemcomposition')?.invalid && (stepFourForm.get('product_systemcomposition')?.dirty || submitted)">
            <option *ngFor="let comp of systemComposition" [ngValue]="comp.id">{{comp.name}}</option>
          </select>
          <div class="text-danger mt-1"
            *ngIf="stepFourForm.get('product_systemcomposition')?.invalid && (stepFourForm.get('product_systemcomposition')?.dirty || submitted)"
            style="font-size: small;">{{"SYSTEM.STEPFOUR.SYSERROR" | translate}}</div>
        </div>
        <div class="col-12 col-md-6">
          <label for="product_systemweco" style="font-weight: bold;">{{"SYSTEM.STEPFOUR.WECOPRODUCTS" |
            translate}}<sup>*</sup></label>
          <select class="form-select" aria-label="select example" id="product_systemweco"
            formControlName="product_systemweco"
            [class.is-invalid]="stepFourForm.get('product_systemweco')?.invalid && (stepFourForm.get('product_systemweco')?.dirty || submitted)">
            <option *ngFor="let weco of wecoComposition" [ngValue]="weco.id">{{weco.name}}</option>
          </select>
          <div class="text-danger mt-1"
            *ngIf="stepFourForm.get('product_systemweco')?.invalid && (stepFourForm.get('product_systemweco')?.dirty || submitted)"
            style="font-size: small;">{{"SYSTEM.STEPFOUR.PRODUCTERROR" | translate}}
          </div>
        </div>
        <div *ngIf="stepFourForm.get('product_systemcomposition')?.value == 3 &&
        (stepFourForm.get('product_systemweco')?.value == 1 || stepFourForm.get('product_systemweco')?.value == 2)" class="col-12 mt-1">
          <span style="font-size: medium; color: red;">
            {{"SYSTEM.STEPFOUR.EXTENDWARRANTY" | translate}}
          </span>
        </div>

        <div class="col-12 col-md-6 mb-3" *ngIf="stepFourForm.get('product_systemcomposition')?.value == 3 &&
          stepFourForm.get('product_systemweco')?.value != null && stepFourForm.get('product_systemweco')?.value != 3">
          <label *ngIf="stepFourForm.get('product_systemweco')?.value == 1" for="brand" style="font-weight: bold;">
            {{"SYSTEM.STEPFOUR.BRANDBATT" | translate}}</label>
          <label *ngIf="stepFourForm.get('product_systemweco')?.value == 2" for="product_brand"
            style="font-weight: bold;">{{"SYSTEM.STEPFOUR.BRANDINV" | translate}}</label>
          <input type="text" name="product_brand" id="product_brand" formControlName="product_brand"
            class="form-control" placeholder="..."
            [class.is-invalid]="stepFourForm.get('product_brand')?.invalid && (stepFourForm.get('product_brand')?.dirty || submitted)">
          <div class="text-danger mt-1"
            *ngIf="stepFourForm.get('product_brand')?.invalid && (stepFourForm.get('product_brand')?.dirty || submitted)"
            style="font-size: small;">
            {{"SYSTEM.STEPFOUR.BRANDERROR" | translate}}
          </div>
        </div>

        <!-- <div class="col-12 form-check form-switch mt-3 ms-3">
          <input class="form-check-input" type="checkbox" role="switch" id="inverter_hybrid"
            formControlName="inverter_hybrid">
          <label class="form-check-label" for="inverter_hybrid">{{ "SYSTEM.STEPFOUR.HYBRIDINVERTER" |
            translate}}</label>
        </div> -->
        <div class="col-12 form-check form-switch mt-3 ms-3">
          <input class="form-check-input" type="checkbox" role="switch" id="inverter_online"
            formControlName="inverter_online">
          <label class="form-check-label" for="inverter_online">{{ "SYSTEM.STEPFOUR.ONLINEINVERTER" |
            translate}}</label>
          <div class="fst-italic text-danger" style="font-size: small;"
            *ngIf="stepFourForm.get('inverter_online')?.value != 1">
            {{ "SYSTEM.STEPFOUR.ONLINEERROR" | translate}}
          </div>
        </div>
      </div>
      <!--BATTERY-->
      <div class="row" *ngIf="stepFourForm.get('product_systemcomposition')?.value == 3 &&
        stepFourForm.get('product_systemweco')?.value != null">
        <div class="col-12 col-md-6 ">
          <label class="mt-3 fw-bold" for="refidwecaresystemvolt" style=" font-size: medium;">
            {{ "SYSTEM.STEPFOUR.VOLTAGE" | translate }}<sup>*</sup>
          </label>
          <select class="form-select" formControlName="refidwecaresystemvolt" id="refidwecaresystemvolt"
            [class.is-invalid]="stepFourForm.get('refidwecaresystemvolt')?.invalid && (stepFourForm.get('refidwecaresystemvolt')?.dirty || submitted)">
            <option [ngValue]="null">{{ "SYSTEM.STEPFOUR.SELECTVALUE" | translate }}</option>
            <option *ngFor="let volt of systemVoltView" [ngValue]="volt.id">
              {{volt.name}}
            </option>
          </select>
          <div class="text-danger mt-1"
            *ngIf="stepFourForm.get('refidwecaresystemvolt')?.invalid && (stepFourForm.get('refidwecaresystemvolt')?.dirty || submitted)"
            style="font-size: small;">
            {{"SYSTEM.STEPFOUR.VOLTAGEERROR" | translate}}
          </div>
        </div>
        <div class="col-12 col-md-6">
          <!-- Modello -->
          <label class="mt-3" for="system_model" style="font-weight: bold; font-size: medium;">
            {{ "SYSTEM.STEPFOUR.SYSTEMMODEL" | translate }}<sup>*</sup>
          </label>
          <select class="form-select" formControlName="system_model"
            [class.is-invalid]="stepFourForm.get('system_model')?.invalid && (stepFourForm.get('system_model')?.dirty || submitted)">
            <option [ngValue]="null" id="system_model">{{ "SYSTEM.STEPFOUR.SELECTMODEL" | translate }}
            </option>
            <option *ngFor="let model of systemModelView" [ngValue]="model.id">
              {{model.name}}
            </option>
          </select>
          <div class="text-danger mt-1"
            *ngIf="stepFourForm.get('system_model')?.invalid && (stepFourForm.get('system_model')?.dirty || submitted)"
            style="font-size: small;">
            {{"SYSTEM.STEPFOUR.MODELERROR" | translate}}
          </div>
        </div>
        <!-- Tipo di batteria -->
        <!-- <div class="col-12 col-md-6">
          <label class="mt-3" for="refidwecaresystemtype" style="font-weight: bold; font-size: medium;">
            <span *ngIf="stepFourForm.get('system_model')?.value != 6; else elseSeries">
              {{ "SYSTEM.STEPFOUR.BATTERYTYPE" | translate }}</span>
            <ng-template #elseSeries>
              {{ "SYSTEM.STEPFOUR.BATTERYSERIES" | translate }}
              </ng-template>
            <sup>*</sup>
          </label>
          <select class="form-select" formControlName="refidwecaresystemtype" id="refidwecaresystemtype"
            [class.is-invalid]="stepFourForm.get('refidwecaresystemtype')?.invalid && (stepFourForm.get('refidwecaresystemtype')?.dirty || submitted)">
            <option [ngValue]="null">{{ "SYSTEM.STEPFOUR.SELECTTYPE" | translate }}</option>
            <option *ngFor="let type of systemTypeView" [ngValue]="type.id">
              {{type.name}}
            </option>
          </select>
          <div class="text-danger mt-1"
            *ngIf="stepFourForm.get('refidwecaresystemtype')?.invalid && (stepFourForm.get('refidwecaresystemtype')?.dirty || submitted)"
            style="font-size: small;">
            {{"SYSTEM.STEPFOUR.BATTERYTYPEERROR" | translate}}
          </div>
        </div> -->
        <!-- <div class="col-12 col-md-6" *ngIf="stepFourForm.get('refidwecaresystemtype')?.value == 14 ||
        stepFourForm.get('refidwecaresystemtype')?.value == 15">
          <label class="mt-3" for="refidwecaresystemakoolsize" style="font-weight: bold; font-size: medium;">
            {{ "SYSTEM.STEPFOUR.BATTERYAKOOL" | translate }}<sup>*</sup>
          </label>
          <select class="form-select" formControlName="refidwecaresystemakoolsize" id="refidwecaresystemakoolsize"
            [class.is-invalid]="stepFourForm.get('refidwecaresystemakoolsize')?.invalid && (stepFourForm.get('refidwecaresystemakoolsize')?.dirty || submitted)">
            <option [ngValue]="null">{{ "SYSTEM.STEPFOUR.SELECTAKOOL" | translate }}</option>
            <option *ngFor="let akool of systemAkool" [ngValue]="akool.id">
              {{akool.name}}
            </option>
          </select>
          <div class="text-danger mt-1"
            *ngIf="stepFourForm.get('refidwecaresystemakoolsize')?.invalid && (stepFourForm.get('refidwecaresystemakoolsize')?.dirty || submitted)"
            style="font-size: small;">
            {{"SYSTEM.STEPFOUR.BATTERYAKOOLERROR" | translate}}
          </div>
        </div> -->
        <div class="col-12 col-md-6" *ngIf="stepFourForm.get('product_systemweco')?.value == 1">
          <!-- Descrivi tipo e modello batterie -->
          <label class="mt-3" for="typebatteries_noweco" style="font-weight: bold; font-size: medium;">
            {{ "SYSTEM.STEPFOUR.BATTERIESNOWECO" | translate }}<sup>*</sup>
          </label>
          <input type="text" name="typebatteries_noweco" id="typebatteries_noweco"
            formControlName="typebatteries_noweco" class="form-control" placeholder="..."
            [class.is-invalid]="stepFourForm.get('typebatteries_noweco')?.invalid && (stepFourForm.get('typebatteries_noweco')?.dirty || submitted)">
          <div class="text-danger mt-1"
            *ngIf="stepFourForm.get('typebatteries_noweco')?.invalid && (stepFourForm.get('typebatteries_noweco')?.dirty || submitted)"
            style="font-size: small;">
            {{"SYSTEM.STEPFOUR.BATTERIESNOWECOERROR" | translate}}
          </div>
        </div>
        <div *ngIf="stepFourForm.get('system_model')?.value != null" class="col-12">
          <label class="form-check-label mt-3 me-3" for="singleBattery">
            {{ "SYSTEM.STEPFOUR.SINGLEBATTERY" | translate }}
          </label>
          <div class="form-check form-check-inline">
            <input class="form-check-input mt-1" type="radio" [value]="1" formControlName="cluster_singlebattery">
            <label class="form-check-label" for="yes">{{ "SYSTEM.STEPFOUR.YES" | translate }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input mt-1" type="radio" [value]="0" formControlName="cluster_singlebattery">
            <label class="form-check-label" for="no">{{ "SYSTEM.STEPFOUR.NO" | translate }}</label>
          </div>
        </div>
        <div class="col-12 col-md-6 mt-2" *ngIf="
        stepFourForm.get('cluster_singlebattery')?.value === 0 &&
        stepFourForm.get('system_model')?.value != null">
          <label for="cluster_numberdevices" style="font-weight: bold; font-size: medium;">
            <span *ngIf="stepFourForm.get('system_model')?.value != 6; else elseCabinet">
              {{ "SYSTEM.STEPFOUR.DEVICESFORCLUSTER" | translate }}</span>
            <ng-template #elseCabinet>{{ "SYSTEM.STEPFOUR.DEVICESFORCABINET" | translate }}</ng-template>
            ?<sup>*</sup>
            <mat-icon *ngIf="stepFourForm.get('system_model')?.value != 6" class="ms-2"
              matTooltip="{{'SYSTEM.STEPFOUR.DESCNUMDEVICE' | translate}}" fontIcon="info"
              style="font-size: medium;"></mat-icon>
          </label>
          <select class="form-select" formControlName="cluster_numberdevices" id="cluster_numberdevices"
            [class.is-invalid]="stepFourForm.get('cluster_numberdevices')?.invalid && (stepFourForm.get('cluster_numberdevices')?.dirty || submitted)">
            <option [ngValue]="null">{{ "SYSTEM.STEPFOUR.SELECTVALUE" | translate }}</option>
            <option *ngFor="let device of numDevicesCluster" [ngValue]="device.num"> {{device.num}}
            </option>
          </select>
          <div class="text-danger mt-1"
            *ngIf="stepFourForm.get('cluster_numberdevices')?.invalid && (stepFourForm.get('cluster_numberdevices')?.dirty || submitted)"
            style="font-size: small;">
            {{"SYSTEM.STEPFOUR.DEVICESFORCLUSTERERROR" | translate}}
          </div>
          <div class="text-secondary " *ngIf="this.stepFourForm.get('refidwecaresystemvolt')?.value == 2">
            {{"SYSTEM.STEPFOUR.HVBOXINFO" | translate}}
          </div>
        </div>
      </div>


    </div>

    <div *ngIf="!isReadonly; else updateBlock" class="col-12 mt-3 text-center px-0">
      <button class="btn btn-outline-dark me-0 me-md-2" (click)="previous()">
        {{"SYSTEM.STEPBUTTONS.PREV" | translate}}
      </button>
      <button class="btn btn-outline-dark ms-1 me-1 ms-md-2 me-md-2" id="next" (click)="saveStep('save')">
        {{"SYSTEM.STEPBUTTONS.SAVE" | translate}}
      </button>
      <button class="btn btn-outline-dark me-0 ms-md-2" [disabled]="stepFourForm.invalid" (click)="saveStep('next')">
        {{"SYSTEM.STEPBUTTONS.NEXT" | translate}}
      </button>
    </div>
    <ng-template #updateBlock>
      <div class="col-12 text-center">
        <button class="btn btn-outline-dark" (click)="approvalRequested()">
          {{"SYSTEM.STEPBUTTONS.UPDATE" | translate}}
        </button>
      </div>
    </ng-template>
  </form>
</div>
